interface FeatureItem {
  icon: string;
  title: string;
  description: string;
}

const FEATURES: FeatureItem[] = [
  {
    icon: "ri-lock-2-line",
    title: "End-to-End Encryption",
    description:
      "Every app we build incorporates robust encryption standards, ensuring user data stays private and protected at every step.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Optimized Performance",
    description:
      "Our apps are engineered for Apple Silicon and iOS internals, delivering snappy, responsive experiences with minimal battery impact.",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Intuitive Interface",
    description:
      "We follow Apple's Human Interface Guidelines rigorously, creating interfaces that feel native, familiar, and effortless to use.",
  },
  {
    icon: "ri-refresh-line",
    title: "Regular Updates",
    description:
      "We continuously release updates to keep our apps compatible with the latest iOS versions, adding improvements based on real user feedback.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    description:
      "Our team is committed to helping users get the most from our apps. We respond quickly to inquiries and take every report seriously.",
  },
  {
    icon: "ri-cpu-line",
    title: "iOS-Native Architecture",
    description:
      "Built exclusively for iOS using native technologies — no cross-platform compromises. This means better reliability, better performance, better apps.",
  },
];

function FeatureCard({ icon, title, description }: FeatureItem) {
  return (
    <div className="group bg-white rounded-2xl p-8 border border-gray-100 transition-all duration-300 hover:-translate-y-1 cursor-default">
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-teal-50 mb-5">
        <i className={`${icon} text-teal-600 text-2xl`} />
      </div>
      <h3 className="text-lg font-bold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
    </div>
  );
}

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-32 bg-gray-50">
      <div className="max-w-screen-xl mx-auto px-8">
        {/* Header */}
        <div className="flex justify-center mb-4">
          <span className="text-xs uppercase tracking-widest font-semibold text-teal-600 bg-teal-50 px-4 py-1.5 rounded-full">
            Why Choose Us
          </span>
        </div>
        <h2 className="text-center text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Built with Precision,
          <br className="hidden md:block" /> Designed with Care
        </h2>
        <p className="text-center text-gray-500 text-lg mb-16 max-w-xl mx-auto">
          Every product we ship embodies our commitment to quality, security,
          and seamless iOS integration.
        </p>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <FeatureCard key={f.title} {...f} />
          ))}
        </div>
      </div>
    </section>
  );
}
